"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _FeedbackButton["default"];
  }
});
exports.render = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _FeedbackButton = _interopRequireDefault(require("./FeedbackButton"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var render = exports.render = function render(options, target) {
  _reactDom["default"].render(/*#__PURE__*/_react["default"].createElement(_FeedbackButton["default"], options), document.getElementById(target));
};